import React from 'react'
import { Env } from '@morningtrain/helpers'

export default function DepartmentService (props) {
  function selectDepartment () {
    Env.transform('globals.department', department => {
      const departments = Env.get('globals.departments', [])

      // if (!department || Object.values(department).length === 0) {
      //   const defaultDepartmentId = Env.get('page.filters.department.defaultValue')
      //
      //   if (defaultDepartmentId) {
      //     if (departments.length > 0) {
      //       departments.forEach(departmentEntry => {
      //         if (parseInt(departmentEntry.id) === parseInt(defaultDepartmentId)) {
      //           department = departmentEntry
      //         }
      //       })
      //     }
      //   }
      // }

      if (!department || Object.values(department).length === 0) {
        if (departments.length === 1) {
          department = Env.get('globals.departments.0', {})
        }
      }

      return department
    })
  }

  selectDepartment()

  React.useEffect(() => {
    const disposer = Env.observe('globals.departments', () => {
      selectDepartment()
    })

    return () => disposer()
  }, [])

  return props.children
}
